import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAdvertDetailContext } from '../../hooks';
import advertDetailContactGroupCss from '../../assets/contacts/contact-group.module.scss';
import { ContactsSocialLink } from './ContactsSocialLink';

const ContactsSocialLinkList: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!('socialLinkList' in contactData)) {
    return null;
  }

  const socialLinkElementList = contactData.socialLinkList.map((item) => (
    <ContactsSocialLink key={item.alias} socialLink={item} />
  ));

  return (
    <div className={advertDetailContactGroupCss.advertDetailContactGroup}>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__header}>
        <FormattedMessage defaultMessage="Apps available:" />
      </div>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__value}>
        {socialLinkElementList}
      </div>
    </div>
  );
};

export { ContactsSocialLinkList };
